<template>

    <v-card>
        <v-card-title>
            {{ isNew ? 'New Network Discovery Request' : 'Edit Network Discovery Request' }}
        </v-card-title>
        <v-divider />
        <v-card-text>
            <v-form ref="networkDiscoveryEditForm" :lazy-validation="true" v-model="formValid">
            <v-row class="mt-3">

                <v-col md="12">
                    <!-- <v-text-field color="#c42111" v-model="$props.networkDiscoveryRequest.network" label="Start Network" hint="Ex: 10.0.0.0/24" persistent-hint :rules="[$store.state.validationFuncs.cidr($props.networkDiscoveryRequest.network)]" /> -->
                    <v-text-field color="#c42111" v-model="$props.networkDiscoveryRequest.network" label="Network" hint="Ex: 10.0.0.0/24" persistent-hint :rules="[isValidCIDRNonPublicIPHost($props.networkDiscoveryRequest.network)]" />
                </v-col>
                <!-- <v-col md="6">
                    <v-text-field color="#c42111" v-model="$props.networkDiscoveryRequest.scan_options.maxHops" label="Max Network Hops" type="number" :rules="[$store.state.validationFuncs.positiveInteger($props.networkDiscoveryRequest.scan_options.maxHops, 'Max Hops')]" />
                </v-col> -->

                <v-col cols="12"><v-divider /></v-col>

                <v-col md="6">
                    <v-checkbox color="#c42111" v-model="$props.networkDiscoveryRequest.scan_options.enablePing" label="Enable Ping" :rules="[oneScanRequired($props.networkDiscoveryRequest.scan_options.enablePing, $props.networkDiscoveryRequest.scan_options.enableSnmp)]" />
                </v-col>
                <v-col md="6">
                    <v-text-field color="#c42111" v-model="$props.networkDiscoveryRequest.scan_options.pingTimeoutSec" :disabled="!$props.networkDiscoveryRequest.scan_options.enablePing" label="Ping Timeout Sec" type="number" :rules="[$store.state.validationFuncs.positiveFloat($props.networkDiscoveryRequest.scan_options.pingTimeoutSec, 'Ping Timeout')]" />
                </v-col>

                <v-col cols="12"><v-divider /></v-col>

                <v-col md="6">
                    <v-checkbox color="#c42111" v-model="$props.networkDiscoveryRequest.scan_options.enableSnmp" label="Enable SNMP Scan" :rules="[oneScanRequired($props.networkDiscoveryRequest.scan_options.enablePing, $props.networkDiscoveryRequest.scan_options.enableSnmp)]" />
                </v-col>
                <v-col md="6">
                    <v-text-field color="#c42111" v-model="$props.networkDiscoveryRequest.scan_options.snmpTimeoutSec" label="SNMP Timeout Sec" :disabled="!$props.networkDiscoveryRequest.scan_options.enableSnmp" type="number" :rules="[$store.state.validationFuncs.positiveInteger($props.networkDiscoveryRequest.scan_options.snmpTimeoutSec, 'SNMP Timeout')]" />
                </v-col>
                <v-col md="6">
                    <v-text-field color="#c42111" v-model="$props.networkDiscoveryRequest.scan_options.snmpCommunityString" label="SNMP Community String" :disabled="!$props.networkDiscoveryRequest.scan_options.enableSnmp" :rules="[$store.state.validationFuncs.requiredIf($props.networkDiscoveryRequest.scan_options.snmpCommunityString, $props.networkDiscoveryRequest.scan_options.enableSnmp, 'SNMP Community String')]" />
                </v-col>
                <v-col md="6">
                    <v-autocomplete autocomplete="off" v-model="$props.networkDiscoveryRequest.scan_options.pm_groups" multiple :items="$props.pmSnmpOptions"  color="#c42111" label="PM Groups" :disabled="!$props.networkDiscoveryRequest.scan_options.enableSnmp" :rules="[$store.state.validationFuncs.requiredIf($props.networkDiscoveryRequest.scan_options.pm_groups, $props.networkDiscoveryRequest.scan_options.enableSnmp, 'SNMP Community String')]" />
                </v-col>
                
                <v-col cols="12"><v-divider /></v-col>

                <v-col md="6">
                    <v-checkbox color="#c42111" v-model="$props.networkDiscoveryRequest.scheduleRun" label="Schedule Network Discovery to Run in the Future" />
                </v-col>
                <v-col md="6">
                    <v-datetime-picker label="Scheduled Run Time" v-model="$props.networkDiscoveryRequest.scheduled_at" :timeFormat="'HH:mm:ss'" :textFieldProps="tfProps" :datePickerProps="dpProps" :timePickerProps="tpProps" v-if="$props.networkDiscoveryRequest.scheduleRun"></v-datetime-picker>
                </v-col>
            </v-row>
            </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions>
            <v-spacer />
            <v-btn text @click="$emit('cancel')" >Cancel</v-btn>
            <v-btn text @click="saveClick" :disabled="$props.networkDiscoveryRequest.running">{{ isNew ? 'Create Request' : 'Save' }}</v-btn>
        </v-card-actions>
    </v-card>

</template>

<script>
export default {
    name: 'NetworkDiscoveryEdit',
    props: ['networkDiscoveryRequest', 'pmSnmpOptions'],
    components: {

    },
    data: () => ({
        formValid: true,
        tfProps: {
            color: '#c42111',
        },
        tpProps: {
            useSeconds: true,
            format: '24hr',
            color: '#c42111',
        },
        dpProps: {
            color: '#c42111',
        },
    }),

    computed: {
        isNew() {
            return !this.$props.networkDiscoveryRequest.request_id;
        }

    },

    methods: {
        isValidCIDRNonPublicIP: function(cidr) {
            // Validate the format of the CIDR (e.g., 192.168.0.0/24)
            const cidrPattern = /^([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})\/([0-9]|[12][0-9]|3[0-2])$/;
            const match = cidr.match(cidrPattern);

            if (!match) {
                return "Invalid Network"; // Invalid format
            }

            const [ip, prefixLength] = match.slice(1, 3);
            const octets = ip.split('.').map(Number);

            // Ensure each octet is within the valid range (0-255)
            if (octets.some(octet => octet < 0 || octet > 255)) {
                return "Invalid Network";
            }

            // Validate if the IP is a non-public (private) IP address
            const isPrivateIP =
                // 10.0.0.0 - 10.255.255.255 (10.0.0.0/8)
                (octets[0] === 10) ||
                // 172.16.0.0 - 172.31.255.255 (172.16.0.0/12)
                (octets[0] === 172 && octets[1] >= 16 && octets[1] <= 31) ||
                // 192.168.0.0 - 192.168.255.255 (192.168.0.0/16)
                (octets[0] === 192 && octets[1] === 168);

            return isPrivateIP || "Must be a private network";
        },

        isValidCIDRNonPublicIPHost: function(cidr) {
            // Validate the format of the CIDR (e.g., 192.168.0.0/24)
            const cidrPattern = /^([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})\/([0-9]|[12][0-9]|3[0-2])$/;
            const match = cidr.match(cidrPattern);

            if (!match) {
                return "Invalid Network"; // Invalid format
            }

            const [ip, prefixLength] = match.slice(1, 3).map((val, index) => index === 1 ? Number(val) : val);
            const octets = ip.split('.').map(Number);

            // Ensure each octet is within the valid range (0-255)
            if (octets.some(octet => octet < 0 || octet > 255)) {
                return "Invalid Network";
            }

            // Validate if the IP is a non-public (private) IP address
            const isPrivateIP =
                (octets[0] === 10) ||
                (octets[0] === 172 && octets[1] >= 16 && octets[1] <= 31) ||
                (octets[0] === 192 && octets[1] === 168);

            if (!isPrivateIP) {
                return "Must be a private network";
            }

            // Convert IP to a 32-bit integer
            const ipAsInt = (octets[0] << 24) | (octets[1] << 16) | (octets[2] << 8) | octets[3];
            // Generate a subnet mask with the prefix length
            const mask = prefixLength === 0 ? 0 : (~0 << (32 - prefixLength)) >>> 0;
            // Ensure host bits are not set by masking IP and comparing with original
            const networkAddress = ipAsInt & mask;

            if (networkAddress !== ipAsInt) {
                return "Host bits are set. Specify a network address without host bits.";
            }

            return true;
        },


        oneScanRequired: function(type1, type2) {
            return (type1 || type2) ? true : 'You must enable at least one type of scan(ping or snmp)';
        },

        saveClick: function() {
            if(!this.$refs.networkDiscoveryEditForm.validate()) {
                return;
            }
            this.$emit('save');
        }
    },

    created() {
        this.$set(this.$props.networkDiscoveryRequest, 'scheduleRun', !!this.$props.networkDiscoveryRequest.scheduled_at);

        let self = this;
        let scheduledRunValidation = function() {
            return self.$props.networkDiscoveryRequest.scheduleRun ? ((!!self.$props.networkDiscoveryRequest.scheduled_at) || 'Required') : true;
        }
        this.tfProps = {rules: [scheduledRunValidation]};
    },

    mounted() {
    }

  
};
</script>
